<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm sending</v-card-title>
    <v-card-text>Are you sure you want to make Proforma invoice {{hefc.hefc_nr}} an offical Invoice and send the invoice to the Host ?  <B> (Sending may take a few seconds)</B></v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="clicked" class="warning mx-2" small @click="tmpHefcToHefc">Yes</v-btn>
      <v-btn :disabled="clicked" color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      clicked: false,
      hefc_encrid: null,
      hefc: {}
    }
  },
  methods: {
    open(hefc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/hefc/getHefcTmp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHefcTmp"
          },
          getHefcTmp: {
            hefc_encrid: hefc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hefc = res.data.getHefcTmp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tmpHefcToHefc() { 
      this.clicked = true;
      this.$axios
        .post("ares/json/ares/eign/hefc/tmpHefcToHefc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "tmpHefcToHefc"
          },
          tmpHefcToHefc: {
            hefc_encrid: this.hefc.hefc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             window.opener.location.reload();
             /*
             setTimeout(() => { this.$router.reload('/eign/hefc/searchHefcTmp'); }, 2000);
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.tmpHefcToHefc.text,
              color: res.data.tmpHefcToHefc.color
            });
            */
            /* this.dialog = false; */
            window.close();

          }
        })
    },
  }
}
</script>

